<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES78UC4']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['20'] }}</div>
                <div class="detail-right">
                    <div class="detail-text  width-70" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text  width-70" id="dtereq" name="dtereq">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['40'] }}</div>
                <div class="detail-right">
                     <div class="detail-text  width-70" id="codlon" name="codlon">{{ detail.tab1.desc_codlon }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['50'] }}</div>
                <div class="detail-right">
                    <div class="input-group width-70">
                        <input type="text" class="form-control input-text" id="amtlonreq" name="amtlonreq" disabled v-model="detail.tab1.amtlonreq" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                </div>
              </div>
            
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['0'] }}</div>
                <div class="detail-right">
                  <div class="input-group width-70">
                      <input type="text" class="form-control input-text" id="numlonreqyr" name="numlonreqyr" disabled v-model="detail.tab1.numlonreqyr" />
                      <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC2']['100'] }}</div>
                  </div>
                  <div class="input-group width-70">
                      <input type="text" class="form-control input-text" id="numlonreqmth" name="numlonreqmth" disabled v-model="detail.tab1.numlonreqmth" />
                      <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC2']['110'] }}</div>
                  </div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['90'] }}</div>
                <div class="detail-right">
                    <div class="detail-text  width-70" id="reaslon" name="reaslon">{{ detail.tab1.reaslon }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['110'] }}</div>
                <div class="detail-right">
                    <div class="detail-text  width-70" id="qtyperiod" name="qtyperiod">{{ detail.tab1.qtyperiod }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['120'] }}</div>
                <div class="detail-right">
                    <div class="input-group width-70">
                        <input type="text" class="form-control input-text" id="amttlpay" name="amttlpay" disabled v-model="detail.tab1.amttlpay" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC4']['130'] }}</div>
                <div class="detail-right">
                    <div class="input-group width-70">
                        <input type="text" class="form-control input-text" id="amtpaybo" name="amtpaybo" disabled v-model="detail.tab1.amtpaybo" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES78UC4']['140'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC8']['20'] }}</div>
                <div class="detail-right">
                     <div class="detail-text  width-70" id="desc_codlon" name="desc_codlon">{{ detail.tab2.desc_codlon }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC8']['30'] }}</div>
                <div class="detail-right">
                    <div class="input-group width-70">
                        <input type="text" class="form-control input-text" id="amtmxlon" name="amtmxlon" disabled v-model="detail.tab2.amtmxlon" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC5']['60'] }}</div>
                    </div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC8']['50'] }}</div>
                <div class="detail-right">
                   <div class="detail-text  width-70" id="ratelon" name="ratelon">{{ detail.tab2.ratelon }}</div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC8']['60'] }}</div>
                <div class="detail-right">
                    <div class="input-group width-70">
                        <input type="text" class="form-control input-text" id="nummxlonyr" name="nummxlonyr" disabled v-model="detail.tab2.nummxlonyr" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC2']['100'] }}</div>
                    </div>
                    <div class="input-group width-70">
                        <input type="text" class="form-control input-text" id="nummxlonmth" name="nummxlonmth" disabled v-model="detail.tab2.nummxlonmth" />
                        <div class="input-group-addon input-group-addon-cust">{{ labels['HRES78UC2']['110'] }}</div>
                    </div>
                </div>
              </div>

              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC8']['100'] }}</div>
                <div class="detail-right">
                    <div class="detail-text  width-70" id="remark" name="remark">{{ detail.tab2.remark }}</div>
                </div>
              </div>

            </div>            
          </div>
        </div>
      </div>
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details3">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES78UC4']['150'] }}
          </h3>
        </div>
        <div id="details3" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive panel-detail-filter">
       
              <div class="clearfix detail-row">
                <div class="detail-left label-left">{{ labels['HRES78UC1']['30'] }}</div>
                <div class="detail-right">
                    <div class="detail-text  width-70" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.codempid }} - {{ detail.tab1.desc_codempid }}</div>
                </div>
              </div>

            </div>
    
            <hrms-table :columns="detailTab3Table" :data="detail.tab3.table" />
                   
          </div>
        </div>
      </div>


    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres78u-detail',
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'detailTab3Table', 'data', 'nowLang' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?2ba2348c